import PriceSummary, {edapTriggerPriceSummaryDisplay} from '@homeaway/react-price-summary';
import React, {Component} from 'react';
import {withTranslationsAsProps} from '../../components/translations';

export const LISTING_STATUS = {
    AVAILABLE: 'AVAILABLE',
    DELISTED: 'DELISTED',
    UNAVAILABLE: 'UNAVAILABLE'
};

export const NoPrice = ({text}) => (<span className="listing-price__no-price">{text}</span>);
export const UnavailablePrice = ({text}) => (<span className="listing-price__unavailable">{text}</span>);

export class ListingPrice extends Component {
    static defaultProps = {
        averagePrice: null,
        edapEventJson: null,
        langAvgNight: '',
        langDatesNotAvailable: '',
        langNoPrice: '',
        priceSummary: null,
        status: null,
        stay: null
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        /* istanbul ignore next */
        const {edapEventJson} = this.props;
        /* istanbul ignore next */
        if (edapEventJson) {
            edapTriggerPriceSummaryDisplay({edapEventJson});
        }
    }

    render() {
        const {
            averagePrice,
            edapEventJson,
            langAvgNight,
            langDatesNotAvailable,
            langNoPrice,
            priceSummary,
            status,
            stay
        } = this.props;
        let formattedAmount = averagePrice && averagePrice.localized || null;
        let pricePeriodDescription = langAvgNight;

        if (status === LISTING_STATUS.DELISTED) {
            return <UnavailablePrice text={langDatesNotAvailable} />;
        }

        // dated, so get price from priceSummary
        if (stay) {
            formattedAmount = priceSummary && priceSummary.formattedAmount || formattedAmount;
            pricePeriodDescription = priceSummary && priceSummary.pricePeriodDescription || pricePeriodDescription;
        }

        if (!formattedAmount) {
            return <NoPrice text={langNoPrice} />;
        }

        return (
            <PriceSummary
                priceSummary={{
                    edapEventJson: edapEventJson || '',
                    formattedAmount,
                    pricePeriodDescription
                }}
            />
        );
    }
}

const allowUndefined = true;
export default withTranslationsAsProps({
    'shared.stabHit.rate.average.night.short': 'langAvgNight',
    'shared.stabHit.rate.none': 'langNoPrice',
    'shared.stabHit.dates.not.available': 'langDatesNotAvailable'
}, allowUndefined)(ListingPrice);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-price.js